require('./brokerFavoriteWidget.scss');

// @vendors
const React= require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const BrokerFavoriteList = require('components/broker/brokerFavoriteList/brokerFavoriteList');

// @constants
const { BROKER_FAVORITE_MAX_LIST_SIZE, BROKER_FAVORITE_START_PAGE_NUM } = require('constants/index');
const { INITIAL_WATCHLIST_EDIT_ID } = require('routes/watchListView/constant');

class BrokerFavoriteWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageNumber: BROKER_FAVORITE_START_PAGE_NUM
        };
        this.onActivePageNumber = this.onActivePageNumber.bind(this);
        this.handleNavigationToSearchPage = this.handleNavigationToSearchPage.bind(this);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.newWatchlistAdded === true) {
            this.setState({
                pageNumber: 1,
            });
        }
    }

    onActivePageNumber(id) {
        this.setState({
            pageNumber: id,
        });
    }

    handleNavigationToSearchPage() {
        this.props.listSelectedForParam(INITIAL_WATCHLIST_EDIT_ID);
        this.props.history.push('/myprofile/broker/explore/');
    }

    buildHeaderContent() {
        const { favoriteContent } = this.props;
        const button = (
            <div className="broker-favorite-widget__cta-wrapper">
                <OKButton modifier="secondary" size="small" onClick={this.handleNavigationToSearchPage}>
                    <FormattedText value="brokerFavoriteWidget-brokerFavoriteWidget_ctaNewText" />
                </OKButton>
            </div>
        );

        return (
            <div className="broker-favorite-widget__cta-block">
                <FormattedText
                    value="brokerFavoriteWidget-brokerFavoriteWidget_Title"
                    className="broker-favorite-widget__subtitle"
                />
                <div>
                    ({favoriteContent.size}/{BROKER_FAVORITE_MAX_LIST_SIZE})
                    {button}
                </div>
            </div>
        );
    }

    buildFooterContent() {
        const { footerLinkText } = this.props;

        return (
            <OKLink
                to="/myprofile/broker/watchlist"
                modifier="widget"
            >
                {footerLinkText}
            </OKLink>
        );
    }

    render() {
        const { favoriteContent, watchlistModalToggle, showWatchlistDetails } = this.props;
        const { pageNumber } = this.state;
        const header = this.buildHeaderContent();
        const footer = this.buildFooterContent();

        return (
            <section className="broker-favorite-widget">
                <header className="broker-favorite-widget__heading-group">
                    {header}
                    <div className="broker-favorite-widget__heading-text">
                        {formatText('brokerFavoriteWidget-brokerFavoriteWidget_heading_text')}
                    </div>
                </header>
                <div className="broker-favorite-widget__content">
                    <BrokerFavoriteList
                        favoriteContent={favoriteContent}
                        handleWatchlistModalToggle={watchlistModalToggle}
                        setPageNumber={this.onActivePageNumber}
                        pageNumber={pageNumber}
                        showWatchlistDetails={showWatchlistDetails}
                    />
                </div>
                <footer className="broker-favorite-widget__footer">
                    {footer}
                </footer>
            </section>
        );
    }
}

BrokerFavoriteWidget.propTypes = {
    history: PropTypes.object.isRequired,
    favoriteContent: PropTypes.array.isRequired,
    footerLinkText: PropTypes.string.isRequired,
    listName: PropTypes.string,
    listSelectedForParam: PropTypes.func,
    newWatchlistAdded: PropTypes.bool,
    showWatchlistDetails: PropTypes.func,
    watchlistModalToggle: PropTypes.func
};

BrokerFavoriteWidget.defaultProps = {
    newWatchlistAdded: false
};

module.exports = withRouter(BrokerFavoriteWidget);
